import { useEffect, useState } from "react";
import { ProductRail } from "@/components/ProductCard";
import { api } from "@/lib/api";

// "Just Added" rail on Home — freshly stocked products (is_new/just_added).
export default function JustAdded() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/just-added").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  if (items.length < 3) return null;
  return (
    <div data-testid="just-added">
      <ProductRail title="Just Added" products={items}
        action={<span className="text-emerald font-semibold text-sm">New on SHOP NOW</span>} />
    </div>
  );
}
